import Navbar from "../Components/Navbar";
import Banner from "../Components/Banner";
import Profile from "../Components/Profile";
import React, { useState } from "react";

const currentMembers = [
  {
    id: 1,
    name: "Eric Guo",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Eric Guo",
    role: "CEO",
    bio: "Eric is a junior from High Technology High School in New Jersey. He attended MOP and Canada/USA Mathcamp in 2026. He also participates in the MIT PRIMES research program. Outside of math, he enjoys physics and talking to people on discord. You can find him on AOPS as eg4334 or on Discord as eric4334.",
  },
  {
    id: 2,
    name: "Satvik Sharma",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Satvik Sharma",
    role: "Head of Logistics",
    bio: "Satvik is a sophomore at Great Valley High School. He qualified for the USAJMO for the first time last year and received an Honorable Mention. He is a member of the Lehigh Valley Math Team and has participated in ARML once. He really enjoys competition math and his favorite math subjects are number theory and algebra. Outside of math, he likes badminton, video games, and speedcubing, having competed in many cubing competitions. He is also active on AoPS and Discord, where he likes to talk with friends."
  },
  {
    id: 3,
    name: "Keshav Karumbunathan",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Keshav Karumbunathan",
    role: "Head of Content Contributor",
    bio: "Keshav is a high school sophomore from Oregon. He has gotten a silver medal on the USAMO and qualified for MOP 2025. He has qualified for the AIME 4 times, and placed silver on USAMTS. His hobbies outside of math include coding, solving puzzles, and swimming."
  },
  {
    id: 4,
    name: "Catherine Ji",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Catherine Ji",
    role: "Outreach",
    bio: "Catherine is a high school junior from Georgia. She is on OMMC’s outreach team, and is passionate about designing social media content and engaging with the math community. She loves mathematical problem solving, and is especially fond of geometry. Outside of math, she is also an archer and a singer. She has won prizes at multiple international vocal competitions and has performed at Carnegie Hall. In her free time, she enjoys baking, curating music, and reading Agatha Christie.",
  },
  {
    id: 5,
    name: "Tiger Li",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Tiger Li",
    role: "Content Contributor",
    bio: "Tiger is a sophomore from Canada. He has qualified for the AIME 6 times, and the CMO, APMO, and USAJMO three times each. He won Top Honors on 2025 JMO with a perfect score, a Bronze medal on 2025 IMO with a score of 21, and a Silver medal on 2025 APMO with a score of 22. In his free time, he plays too many video games and reads way too much manga. Unfortunately, he has never had a perfect score on the AMC 8 or Gauss contests."
  },
  {
    id: 6,
    name: "Ethan Imanuel",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Ethan Imanuel",
    role: "Content Contributor",
    bio: "Ethan is currently a freshman at Chatham High School in New Jersey. He has qualified the JMO twice and MATHCOUNTS Nationals twice. Apart from math, he enjoys coding, playing trombone, fencing, and playing videogames in his free time."
  },
  {
    id: 7,
    name: "Eddy Zhang",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Eddy Zhang",
    role: "Content Contributor",
    bio: "Eddy is a sophomore from Parkland High School in Pennsylvania. He has qualified for AIME four times, JMO once, Mathcounts Nationals twice, and was one of the top 20 students at the ARML competition in 2025. Out of all the subjects, he enjoys number theory and algebra the most. He also enjoys piano, tennis, and wasting time online watching ping pong or clash royale."
  },
  {
    id: 8,
    name: "Andrew Chai",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Andrew Chai",
    role: "Content Contributor",
    bio: "Andrew is a junior from New Jersey. He has qualified for the AIME 3 times and for the USAJMO two times, getting Honors last year. Andrew especially likes olympiad combinatorics and geometry problems. Aside from math, he likes to swim and play the piano."
  },
  {
    id: 9,
    name: "Rayoon Kim",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Rayoon Kim",
    role: "Content Contributor",
    bio: "Rayoon is a sophomore from Lower Merion High School in Pennsylvania. He has qualified for AIME since 7th grade and has achieved other distinctions such as AMC10, 8 DHR and has placed top 25 in mathcounts. His favorite math subject is algebra, followed by algebra disguised in a geometry problem. Besides math he loves esports, gaming, reading, and discord. Message him on lostriptide on discord."
  },
  {
    id: 10,
    name: "Kevin Long",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Kevin Long",
    role: "Content Contributor",
    bio: "Kevin's a MOP attendee from New Jersey. He's a freshman currently and hopes to go to IMO someday."
  },
  {
    id: 11,
    name: "Arjun Suresh",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Arjun Suresh",
    role: "Content Contributor",
    bio: "Arjun is a sophomore at Middleton High School in Wisconsin. He is a two-time AIME qualifier and received honors on USAJMO in 2025. Apart from math, he enjoys listening to music, writing, and occasionally playing tennis."
  },
  {
    id: 12,
    name: "Tarun Rapaka",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Tarun Rapaka",
    role: "Content Contributor",
    bio: "Tarun is a junior from The Woodlands, Texas. In 2024 he qualified for the USAJMO and got Honors, 2 points shy of the MOP cutoff. He is also a 3-time AIME qualifier, a 2023 AMC 10 perfect scorer, a 2-time ARML Team High Scorer, and a USAMTS Silver medalist. He was an attendee of Canada/USA Mathcamp 2024. In his spare time, he likes to work on hard Olympiad geometry problems. His hobbies include piano, rock climbing, and speed cubing.",
  },
  {
    id: 13,
    name: "Casi",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Casi",
    role: "Content Contributor",
    bio: "Casi is an 11th grader from Oregon. She qualified for USAJMO for the first time last year. She really enjoys solving math problems, especially number theory. In her spare time, she likes to solve math puzzles, play the piano, and exercise.",
  },
  {
    id: 14,
    name: "Akshaj Arora",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Akshaj Arora",
    role: "Content Contributor",
    bio: "Akshaj is a sophomore at Northview High School in Georgia. His math achievements include USAJMO Honors, 3x MATHCOUNTS Nationals, and Distinguished Honor Roll in AMC-10. Apart from Math, he loves programming and knows JavaScript, Typescript, Python, and C++. He also plays Clarinet and video games in his free time.",
  },
  {
    id: 15,
    name: "Vihaan Gupta",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Vihaan Gupta",
    role: "Content Contributor",
    bio: "Vihaan is a current sophomore who qualified for USA(J)MO for the first time last year. He participated on the SFBA/NorCal A1 team in ARML, and he enjoys participating in various competitions (as well as writing a few).",
  },
  {
    id: 16,
    name: "Eden He",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Eden He",
    role: "Content Contributor",
    bio: "Eden is a senior at Garnet Valley High School who attended MOP in 2025. He is a participant on the Lehigh Valley ARML Fire team, and enjoys playing chess and tractor in his spare time.",
  },
  {
    id: 17,
    name: "Krithik Manoharan",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Krithik Manoharan",
    role: "Content Contributor",
    bio: "Krithik is a current sophomore from Houston, TX. He has qualified to AIME 4 times and USA(J)MO 3 times, and attended MOP in 2026. Out of all of the subjects, he enjoys algebra the most: he won top 10 in PuMAC Algebra twice, top 10 in HMMT February Algebra once, and won 1st in the 2026 CMIMC Algebra round. He also hosts his own math competition, KNMC, which reached over 350 participants. Aside from math, he enjoys puzzles and card games (especially fish).",
  },
  {
    id: 18,
    name: "Joshua Liu",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Joshua Liu",
    role: "Content Contributor",
    bio: "I’m Joshua, I’m a junior at Cherry Creek High School in Colorado. My favorite math subject is probably NT. When I’m not doing math I enjoy swimming, listening to music, and watching sports.",
  },
  {
    id: 19,
    name: "Luca Pieleanu",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Luca Pieleanu",
    role: "Content Contributor",
    bio: "Luca is currently a junior at Sharon High School in Massachusetts. He has qualified for USAJMO twice in 8th grade and 9th grade and USAMO once in 10th grade. He is also part of the MIT PRIMES math research program. Aside from math, he does research in statistical physics and network science and has an Erdős number of 4. You can find him on AoPS as lpieleanu.",
  },
  {
    id: 20,
    name: "Ben Jump",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Ben Jump",
    role: "Content Contributor",
    bio: "Ben is a Senior from Cincinnati Ohio. He has qualified for the AIME since 2023, eventually receiving USAJMO Honors in 2025, and USAMO Bronze in 2026. He attended SUMaC in 2026. Inside of math he is a combinatorics antimain. Outside of Math, he enjoys running XC and track, playing game pigeon word hunt, and being with friends.",
  },
  {
    id: 21,
    name: "Adam Smith",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Adam Smith",
    role: "Content Contributor",
    bio: "Adam is a junior attending Hershey High School in Pennsylvania. He has qualified for AIME three times and JMO once, and he attended MOP in 2026. He also enjoys playing the trumpet, studying math and science, playing chess, and playing frisbee. He also participates in FRC, Science Olympiad, his school chess club, marching band, and helping out the MATHCOUNTS team! Find him as adammith_ on Discord.",
  },
  {
    id: 22,
    name: "Lam To",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Lam To",
    role: "Content Contributor",
    bio: "Lam is a high school junior at Bergen County Academies. He has qualified for USAMO, missing a bronze medal by 1 point, and hopes to get his revenge and make MOP next year.",
  },
];

const pastMembers = [
  {
    id: 1,
    name: "Evan Chang",
    href: "#",
    imageSrc: "/staff/evan.png",
    imageAlt: "Evan Chang",
    bio: "Evan Chang is a student at MIT and was the previous CEO for OMMC. In 2023, he was a USAMO Gold Medalist and placed 12th out of all students nationwide.  He was a MOP camper in 2022 and 2023 and is a SPARC camper in 2023. He is an intern for LIVE by Po Shen Loh. Evan also currently studies piano and music composition.",
  },
  {
    id: 2,
    name: "Ishaan Akula",
    href: "#",
    imageSrc: "/staff/ishaan.png",
    imageAlt: "Ishaan Akula",
    bio: "Ishaan is a student at Stanford University. He cofounded OMMC with Evan Chang in September of 2020, and worked as a director for OMMC and handled the partnership and impact aspect of the competition, including work with sponsors, partners, and donors. He was awarded Honorable Mention for Environmental Science in the Jersey Shore Science Fair. He won 1st place at the state-wide regional bee, qualifying for the National Scripps Spelling Bee. He specializes in UI/UX design and mobile app development using Flutter programming. Furthermore, he is actively involved in the Performing Arts, demonstrating leadership and acting skills in school musicals and performing with his a cappella group, 'Tech-appella.'",
  },
  {
    id: 3,
    name: "Alexander Wang",
    href: "#",
    imageSrc: "/staff/alexander.png",
    imageAlt: "Alexander Wang",
    role: "CEO",
    bio: "Alexander is currently a senior at Millburn High School. He is a 3-time IMO Gold Medalist in 2023, 2024, and 2025. He won a gold medal at RMM 2023 and APMO 2024. He is a 3-time USAMO Gold Medalist and obtained a perfect score in 2023. He attended the prestigious MOP program from 2022-2025. He attended the MIT PRIMES-USA math research program in 2024 and 2025. In his spare time, he enjoys playing sports, especially tennis.",
  },
  {
    id: 4,
    name: "Bill Fei",
    href: "#",
    imageSrc: "/staff/bill.png",
    imageAlt: "Bill Fei",
    bio: "Bill Fei is a student Columbia University. He was an assistant director for OMMC and a Coca-Cola Scholarship Seminfinalist. He participates in competitive programming and competition math. He is a USACO Gold Medalist, a three-time AIME qualifier, and has achieved Distinguished Honor Roll on the AMC 10. He won first place in the ICTM math competition in Indiana, and coaches his school’s MATHCOUNTS team. Besides math, he does many other things in his spare time. He enjoys playing the viola and has been in the Indiana All-State Orchestra 2 years in a row and was the sectional principle of the viola section for both his years in the Indiana Junior All-State Orchestra. He also studies piano and has won awards at the Indiana State Fair piano competition. In addition, he enjoys being on his school’s debate team. He was on his school’s state Public Forum debate roster, and placed 5th at his district’s Congressional Debate. In his free time, he enjoys procrastinating and sleeping.",
  },
  {
    id: 5,
    name: "Kevin Liu",
    href: "#",
    imageSrc: "/staff/kevin.png",
    imageAlt: "Kevin Liu",
    bio: "Kevin is a student at Princeton University. He attended the Governor's School of Engineering and Technology in New Jersey and is currently an SWE intern at Bloomberg LP. He cofounded OMMC with Evan Chang in September of 2020, and currently works as the Chief Technology Officer for OMMC, handling the online aspect of the competition, including the official OMMC Website, Test Portal, and OMMC Atlas. He uses the latest frontend/backend languages and technologies including Next13, Typescript, React, and Tailwind. He also enjoys participating in college hackathons like PennApps at the University of Pennsylvania.",
  },
  {
    id: 6,
    name: "Advika Vuppala",
    href: "#",
    imageSrc: "/staff/advika.jpeg",
    imageAlt: "Advika Vuppala",
    bio: "Advika Vuppala is a student at Carnegie Mellon University. She worked on Marketing and Social Media for OMMC last year, and also helped with content creation for the website. This year, she helped with Outreach and Social Media. Advika served as Marketing and Outreach director for cypHER, and has a lot of experience with managing professional social media accounts. In her free time, she loves playing lacrosse, baking, hiking, and biking.",
  },
  {
    id: 7,
    name: "Ananya Vuppala",
    href: "#",
    imageSrc: "/staff/ananya.jpeg",
    imageAlt: "Ananya Vuppala",
    bio: "Ananya is a student at Yale University. She was on OMMC's social media and outreach team, and helped out with making flyers and exploring social media design. She's a math tutor for students in elementary and middle school, and loves working with students to be able to work on their strengths and weaknesses and be part of their learning experience. A few of her hobbies include playing lacrosse, designing content, hiking, exploring finance, and many more. Ananya loves meeting new people and trying new things!",
  },
  {
    id: 8,
    name: "Vinay Singamsetty",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Vinay Singamsetty",
    role: "Website Developer",
    bio: "Vinay was a developer for OMMC and contributed greatly to the testing portal and website. He is an avid developer and is skilled at developing web applications focused on responsive design, positive UX/UI, SEO and more. He is fluent in React/Next, Vue/Nuxt, JS/HTML/CSS, Sass and general purpose languages like Node JS, Python, C++, C, C#, Java, and more. He's good at developing algorithms and vital coding concepts such as control flow, program structure, versioning, debugging, and formatting. He is also a math enthusiast, achieving honor roll on AMC 8 previously and is currently working on honing his math skills.    ",
  },
  {
    id: 9,
    name: "Pranshu Suyal",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Pranshu Suyal",
    role: "CTO",
    bio: "Pranshu is a student at the University of North Carolina, and was the CTO for OMMC. He is an avid engineer fluent in the latest web frameworks, including React, TypeScript, and Next, as well as general-purpose languages like Python, Java, and C++. He enjoys working on startup ideas and is also an AIME qualifier.",
  },
  {
    id: 10,
    name: "Andrew Lin",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Andrew Lin",
    role: "Content Contributor",
    bio: "Andrew Lin is a student at MIT. He wrote problems for OMMC. He has qualified for MOP four times and is a USAMO gold medalist. In addition, he has achieved top-ten finishes at HMMT and ARML, and was part of the Lehigh Valley Fire team. He goes by bluelinfish on AoPS and Discord. Outside of math, he spends too much of his time playing card games.",
  },
  {
    id: 11,
    name: "Isaac Chen",
    href: "#",
    imageSrc: "/staff/isaac.png",
    imageAlt: "Isaac Chen",
    role: "Content Contributor",
    bio: "Isaac Chen is a student at MIT. He has contributed original problems to OMMC and helped organize the 2024 Rutgers Exposition in Problem Solving (REPS). Isaac is a 2023 USAJMO Top Winner, 2024 USAMO Silver Medalist, and attended MOP 2023. He also proudly captains the nationally renowned Lehigh Valley Math Team. Last summer, Isaac attended Research Science Institute (RSI) 2024 and conducted research in discrete geometry. He loves spreading his passion for problem solving through other outlets, including as a host of The Curious Cube, the official American Mathematics Competitions (AMC) student podcast sponsored by the Mathematical Association of America (MAA). Outside of math, Isaac enjoys hanging out with friends, playing and watching basketball, high-quality writing, learning to cook, and speedcubing.",
  },
  {
    id: 12,
    name: "Rohan Bodke",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Rohan Bodke",
    role: "Content Contributor",
    bio: "Rohan is a student at MIT. He worked for OMMC as a content contributor. He attended MOP and started math contests in 2018, when he was in sixth grade. Since then, he has qualified for the AIME three times, and the USAJMO twice, winning it in 2022. He was also part of California's MATHCOUNTS team in 2021, and was sixteenth place at nationals. In addition to math, he likes to play chess and other board games, both with his friends and online. He also enjoys doing extremely weird things no one else would do, such as reading WP:UA. He was a top 20 player in the now-defunct mobile game _Big Bang Racing_.",
  },
  {
    id: 13,
    name: "Sargam Mondal",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Sargam Mondal",
    role: "Content Contributor",
    bio: "Sargam is a student at MIT. She was an avid competitor in math competitions, having placed 1st, 2nd, and 3rd at ARML in 2023, 2022, and 2024 respectively. Additionally, she is a two-time PUMaC Division A Individual Finalist, placed in the top 50 at HMMT February subject tests, and ranked in the top 10 at Girls in Math at Yale. She is also a participant in the MIT PRIMES-USA program. Outside of math competitions, she is very interested in algebraic geometry.",
  },
  {
    id: 14,
    name: "Andrew Brahms",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Andrew Brahms",
    role: "Content Contributor",
    bio: "Andrew is a student at MIT. He was a researcher under the MIT PRIMES-USA Program and USAJMO Honorable Mention. He has qualified for the AIME five times and made Distinguished Honor Roll for the AMC 10. Outside of math, Andrew enjoys swimming and bicycling. ",
  },
  {
    id: 15,
    name: "Vivian Loh",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Vivian Loh",
    bio: "Vivian Loh is a student at Caltech who worked as a content contributor for OMMC. She is a 2-time EGMO gold medalist (in 2022 and 2023) and is a 3-time MOP qualifier.",
  },
  {
    id: 16,
    name: "Aprameya Tripathy",
    href: "#",
    imageSrc: "/staff/aprameya.jpg",
    imageAlt: "Aprameya Tripathy",
    role: "Head of Content Revision",
    bio: "Aprameya Tripathy is a student at MIT. He worked as the head of content revision at OMMC. He has attended MOP twice and is a USAMO gold medalist. In his free time, you can find him baking various confections, writing geometry problems, and teaching math to others.",
  },
  {
    id: 17,
    name: "Tanishq Pauskar",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Tanishq Pauskar",
    role: "Head of Content Revision",
    bio: "Tanishq Pauskar enjoys solving and writing math problems. He is particularly fond of the subject combinatorics. Over the past few months, Tanishq has worked to test solve the OMMC exam. He has qualified for the USAJMO 3 times, becoming a USAJMO winner in 2022. In his spare time, he enjoy writing math problems and playing board games such as chess and connect 4.",
  },
  {
    id: 18,
    name: "Ritwin Narra",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Ritwin Narra",
    role: "Content Creation",
    bio: "Ritwin is a student at Stanford. He was a Test Solver for OMMC. Ritwin has qualified for USACO camp and has qualified for the AIME since 7th grade, and his math accomplishments include a 72 on USAMTS and a 24 on BAMO (one point under Honorable Mention). In school, he teaches both programming and math. Apart from math, he loves coding: he's a USACO Platinum participant and reached Codeforces Master. Also, he likes cubing, especially the Square-1, and aims for a sub-20 3x3 average.",
  },
  {
    id: 19,
    name: "Chris Bao",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Chris Bao",
    role: "Problem Committee",
    bio: "Chris Bao is a student at MIT. He has qualified for the USAJMO three times and the USAMO in 2023. He has also participated in MOP 2022 and MOP 2023. Besides math, Chris also plays chess, piano, and works on coding a chess engine in his free time.",
  },
  {
    id: 20,
    name: "Srinivas Arun",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Srinivas Arun",
    bio: "Srinivas Arun is a student at MIT. He was a testsolver for OMMC. Srinivas has attended RSI and received a bronze medal on USAMO 2022, qualifying for MOP. He has participated in math competitions since 6th grade, qualifying for the AIME four times and the USA(J)MO three times. He has also qualified for MathCounts Nationals, representing Colorado, and he was the 3rd place individual at ARML 2021. Outside of math, he enjoys competitive programming, biking, and teaching.",
  },
  {
    id: 21,
    name: "Sheldon Tan",
    href: "#",
    imageSrc: "/staff/sheldon.png",
    imageAlt: "Sheldon Tan",
    bio: "Sheldon Tan graduated from Monte Vista High School in Danville, California. He qualified for the USAJMO in 2022 and spent the last two summers at the Ross Math Program. Besides math, he enjoys playing the piano, writing, hiking, and Frisbee.",
  },
  {
    id: 22,
    name: "Neal Yan",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Neal Yan",
    bio: "Neal is a geometry addict hailing from Wisconsin, serving as a problem writer / testsolver / marketer for OMMC. He has attended MOP and is also the chief math officer of the regional organization known as Youth EUCLID Association. In math contests, he's made USA(J)MO since 8th grade, and has achieved multiple individual top fives at collegiate math tournaments like BMT, SMT, and JHMT. During most of the day, he enjoys solving and attempting to write olympiad problems, grinding OTIS, spamming / calling friends on Discord, listening to electronic songs, and blogging on AoPS under the username 'crazyeyemoody907'.",
  },
  {
    id: 23,
    name: "Culver Kwan",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Culver Kwan",
    role: "Content Contributor",
    bio: "Culver graduated from Diocesan Boys' School in Hong Kong. He enjoys both mathematics and programming, and participates in olympiads for both of them. He participated in IMO 2023, 2024, 2025, 2026 and got bronze, silver, gold, and silver medals respectively, and got a silver medal at IOI 2024. His peak rank on Codeforces is Grandmaster. He has also done research on graph theory in the summer leading up to his sophomore year. He likes writing both math problems and informatics problems, and has set a number of quality problems in both. ",
  },
  {
    id: 24,
    name: "Vikram Sarkar",
    href: "#",
    imageSrc: "/staff/vikram.jpg",
    imageAlt: "Vikram Sarkar",
    role: "Content Contributor",
    bio: "Vikram Sarkar is a test solver for the OMMC team. His achievements include qualifying for the USA Junior Math Olympiad (USAJMO) three times and qualifying for the prestigious Math Olympiad Program (MOP) in 2024. Outside of math, he likes playing video games, listening to music, and coding.",
  },
  {
    id: 25,
    name: "Bryan Guo",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Bryan Guo",
    role: "Content Contributor",
    bio: "Bryan Guo is a problem contributor for the OMMC team and is currently a junior. He has achieved Distinguished Honor Roll on the AMC 10 several times, and qualified for the 2022 USAJMO. He is a two-time USAMTS silver medalist and has participated in the A2 team for SD ARML. In the 2022 AMC cycle, he achieved a perfect score on the AMC 10. Apart from math, he enjoys playing tennis and talking on Discord.",
  },
  {
    id: 26,
    name: "Charles Zhang",
    href: "#",
    imageSrc: "/staff/charles.jpeg",
    imageAlt: "Charles Zhang",
    role: "Head of Logistics",
    bio: "Charles is a senior in Southern California, and is the Head of Logistics for OMMC.  He is a 4-time Math Olympiad qualifier, and has scored 11 on the AIME 4 years in a row.  He is a researcher under the MIT PRIMES-USA program, and an attendee of Ross Indiana 2023 and SPARC 2024.  In his free time, he likes to play difficult 2017-2018 indie games, such as Hollow Knight, Celeste, and Cuphead.",
  },
  {
    id: 27,
    name: "Mahith Gottipati",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Mahith Gottipati",
    role: "Head of Content Creation",
    bio: 'Mahith is a senior from Texas. He has qualified for the AIME three times and has placed well in several other contests. Apart from mathematics, he enjoys physics, coding, and playing table tennis and chess. You can find him on chess.com under the handle "rocketsrimsg," where he plays (a little too much) puzzle rush. ',
  },
  {
    id: 28,
    name: "Sagarika Yagnyeshwaran",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Sagarika Yagnyeshwaran",
    role: "Head of Outreach",
    bio: "Sagarika is a high school senior in Manalapan High School's Science and Engineering Program. She is OMMC's Head of Outreach and makes flyers, posters, and other social media content. She is a math tutor and is predominantly interested in statistics. In her free time, she plays piano and has won various international competition for it, including the chance to perform at Carnegie hall. A few of her interests include finance, politics, music, and reading. Sagarika is always open to trying new things and meeting all kinds of people!",
  },
  {
    id: 29,
    name: "Darren Han",
    href: "#",
    imageSrc: "/staff/default.png",
    imageAlt: "Darren Han",
    role: "Content Contributor",
    bio: "Darren is currently a junior at Westwood High School. He attended MOP in 2025 and won a gold medal on the USAMO. He qualified for the USAMO twice and USAJMO twice. He is also a researcher under the MIT PRIMES-USA program. Apart from math, he enjoys physics, competitive programming, playing the violin, and listening to music."
  },
];

export default function Staff(props) {
  const [activeTab, setActiveTab] = useState("current");

  return (
    <div
      className={
        (props.dark ? "dark " : "") +
        "min-h-screen bg-slate-100 dark:bg-gray-900 duration-150"
      }
    >
      <Navbar page="staff" dark={props.dark} setDark={props.setDark} />
      <Banner />
      <header className="drop-shadow-lg duration-150 bg-white dark:bg-[#182133]">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <h1 className="text-4xl font-extrabold text-gray-900 dark:text-slate-100">
            Staff
          </h1>
          <div className="flex rounded-lg overflow-hidden border border-red-800 dark:border-white">
            <button
              className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                activeTab === "current"
                  ? "bg-red-800 text-white dark:bg-white dark:text-red-800"
                  : "bg-white text-red-800 hover:bg-red-100 dark:bg-[#182133] dark:text-white dark:hover:bg-gray-800"
              }`}
              onClick={() => setActiveTab("current")}
            >
              Current
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                activeTab === "past"
                  ? "bg-red-800 text-white dark:bg-white dark:text-red-800"
                  : "bg-white text-red-800 hover:bg-red-100 dark:bg-[#182133] dark:text-white dark:hover:bg-gray-800"
              }`}
              onClick={() => setActiveTab("past")}
            >
              Former
            </button>
          </div>
        </div>
      </header>
      <div className="w-full mx-auto max-w-7xl px-4 md:px-10 pt-10">
        <div className="mt-6 grid grid-cols-1 md:gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8">
          {(activeTab === "current" ? currentMembers : pastMembers).map(
            (member) => (
              <Profile key={member.id} member={member} />
            )
          )}
        </div>
      </div>
    </div>
  );
}
